module.exports = __webpack_public_path__ + "img/MapPicsLowlandGroves.0cbaccd8.webp";